import React from "react";

import DynamicRoute from "$src/core/components/templates/DynamicRoute/DynamicRoute";

const Route: React.FC = () => <DynamicRoute slot={7} />;

export default Route;
